export { SocialBetTable } from './SocialBetTable'
export { MarbleBetTable } from './MarbleBetTable'
